import styled from 'styled-components';

export const DiscountListContainer = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;

    .discount {
        color: ${props => props.theme.partnerCardDiscountListTextColor};

        .value {
            font-size: 14px;
            color: ${props => props.theme.partnerCardDiscountListDiscountColor};
            font-weight: ${props => props.theme.partnerOfferMainValueWeight};
        }
        .svg-fleche {
            width: 6px;
            height: 10px;
            margin: 7px 12px 0 0;
            path {
                fill: ${props => props.theme.partnerCardDiscountIcon};
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/discount/DiscountListComponentStyle.js